























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { StatusProfile as IProfile } from "@/api-v2/learning-requests/models";
import { LearningRequest as ILearningRequest } from "@/api-v2/learning-requests/models/learning-request";
import { getCurrentCompanyId } from "@/plugins/roles";
import api, { learningRequestApi } from "@/getinfo-api";
import CustomButton from "@/components/form/CustomButton.vue";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import Modal from "@/components/form/Modal.vue";
import CourseRegistrationsTable from "@/components/courses/CourseRegistrationsTable.vue";

@Component({
  components: {
    CourseRegistrationsTable,
    Modal,
    CustomButton,
    CustomTableCol,
    CustomTableItem
  }
})
export default class LearningRequestTableItem extends Vue {
  @Prop() item!: ILearningRequest;
  @Prop() profile!: IProfile;
  @Prop() isLoading!: boolean;
  status!: string;
  isStatusChanging: boolean = false;

  responsibleId!: string;

  data() {
    return {
      responsibleId: undefined,
      status: undefined
    };
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }
  changeStatus() {
    this.isStatusChanging = true;
    learningRequestApi.Request.changeRequestStatus(this.item.id, {
      statusId: this.status
    })
      .then(async res => {
        this.item = res.data;
        await this.$store.dispatch("successToast", {
          message: this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved)
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.status = this.item.statusId;
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })

      .finally(() => {
        this.isStatusChanging = false;
      });
  }

  getEmployee() {
    api.EmployeeApi.get(this.selectedCompanyId, this.item.responsibleId).then(
      res => {
        this.responsibleId = res.data.user.id;
      }
    );
  }
  created() {
    this.getEmployee();
    this.status = this.item.statusId;
  }
}
